import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators, AbstractControl, FormControl } from '@angular/forms';
import { ClusterService } from '../cluster.service';
import { Building } from '../../building/building.interface';
import { Cluster } from '../cluster.interface';

@Component({
  selector: 'sg2-cluster-add',
  templateUrl: './cluster-add.component.html',
  styleUrls: ['./cluster-add.component.less']
})
export class ClusterAddComponent implements OnInit {

  /** Parent building. */
  private building: Building;

  /** Form. */
  public form: FormGroup;

  constructor(
    @Inject(MAT_DIALOG_DATA) public readonly config: any,
    public dialogRef: MatDialogRef<ClusterAddComponent>,
    private formBuilder: FormBuilder,
  ) {
    this.building = config.building;
  }

  ngOnInit() {
    this._setForm();
  }

  /**
   * Submit and add cluster.
   */
  public submit(): void {
    this.dialogRef.close(this.form.value as Partial<Cluster>);
  }

  /**
   * Initialize form and set validators.
   */
  private _setForm(): void {
    this.form = this.formBuilder.group({
      name: [null, [
        Validators.required,
        this._uniqueNameValidator.bind(this)
      ]],
      shortCode: [null, [
        Validators.required,
        Validators.maxLength(5),
        this._uniqueShortCodeValidator.bind(this)
      ]]
    });
  }

  /**
   * Check if the name is unique.
   *
   * @param control The current form control.
   */
  private _uniqueNameValidator(control: FormControl): void {
    const names = this.building.clusters
      .filter(c => c.active)
      .map(c => c.name);
    if (control.valid) {
      if (names.indexOf(control.value) > -1) {
        setTimeout(() => {
          control.setErrors({ unique: true });
        });
      }
    }
  }

  /**
   * Check if the shortcode is unique.
   *
   * @param control The current form control.
   */
  private _uniqueShortCodeValidator(control: FormControl): void {
    const shortCodes = this.building.clusters
      .filter(c => c.active)
      .map(c => c.shortCode);
    if (control.valid) {
      if (shortCodes.indexOf(control.value) > -1) {
        setTimeout(() => {
          control.setErrors({ unique: true });
        });
      }
    }
  }
}
